import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faTimesCircle} from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import {faSignOut} from '@fortawesome/pro-solid-svg-icons/faSignOut';
import {faCalendarDay} from '@fortawesome/pro-regular-svg-icons/faCalendarDay';

import Base from 'Components/Base/Base';
import {Button} from 'Components/Partials/Form';
import {Loading} from 'Components/Partials/Layouts';
import {withRouter} from 'react-router-dom';

import Attendance from 'Services/Api/HumanResource/Attendance';

/**
 * @classdesc Dashboard page for viewing your holiday available
 */
class CheckIn extends Base {
    state = {
        working: false,
    };

    /**
     * @method handleCheckIn
     * @param {boolean} onEvent
     * @return {Promise<void>}
     */
    handleCheckIn = async (onEvent = false) => {
        this.working();

        const request = await Attendance.checkIn(null, {
            present: true,
            on_event: onEvent,
        });

        if (request.status !== 201 && request.status !== 200) {
            return this.toastError('Sorry, there was a problem processing your check in');
        }

        this.toastSuccess('Your attendance has been registered!');

        this.props.history.push('/noticeboard');

        if (this.props.callback) {
            this.props.callback();
        }

        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    /**
     * @method handleCheckOut
     * @return {Promise<void>}
     */
    handleCheckOut = async () => {
        if (this.props.attendance === undefined || this.props.attendance === null) {
            return;
        }

        this.working();

        const request = await Attendance.checkOut(this.props.attendance.id);

        if (request.status !== 200) {
            this.toastError('Sorry, there was a problem processing your check out');
            return;
        }

        this.toastSuccess('Your attendance has been updated!');

        if (this.props.callback) {
            this.props.callback();
        }
    };

    /**
     * @method renderSymbol
     * @param {object} attendance
     * @return {*}
     */
    renderSymbol = (attendance) => {
        if (attendance.present && attendance.check_out === null) {
            if (attendance.on_event) {
                return (
                    <div className="text-green-500" title="You've checked in">
                        <FontAwesomeIcon icon={faCalendarDay} size="5x" />
                    </div>
                );
            }

            return (
                <div className="text-green-500" title="You've checked in">
                    <FontAwesomeIcon icon={faCheckCircle} size="5x" />
                </div>
            );
        }

        if (attendance.present && attendance.check_out !== null) {
            return (
                <div className="text-green-500" title="You've checked out">
                    <FontAwesomeIcon icon={faSignOut} size="5x" />
                </div>
            );
        }

        return (
            <div className="text-red-500" title="You have not checked in yet">
                <FontAwesomeIcon icon={faTimesCircle} size="5x" />
            </div>
        );
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const {working} = this.state;
        const {attendance} = this.props;

        return (
            <React.Fragment>
                <div className="flex-col text-center">
                    {working && (<Loading />)}

                    {attendance !== null && this.renderSymbol(attendance)}

                    {!working && attendance === null && (
                        <div>
                            <Button onClick={() => this.handleCheckIn(false)}>
                                Check In
                            </Button>

                            <Button
                                onClick={() => this.handleCheckIn(true)}
                                className="ml-4"
                            >
                                On Event
                            </Button>
                        </div>
                    )}

                    {!working && attendance !== null && attendance.here && (
                        <Button onClick={this.handleCheckOut} className="mt-4">
                            Check Out
                        </Button>
                    )}

                    {!working && attendance !== null && !attendance.here && (
                        <Button onClick={() => this.handleCheckIn(false)} className="mt-4">
                            Check In
                        </Button>
                    )}
                </div>
            </React.Fragment>
        );
    };
}

export default withRouter(CheckIn);
